import React from 'react';
import { ManagedPopup } from 'js/components/common/Popup';
import { useCombinedOnClose } from 'js/components/common/PopupManager';
import { ChangeLimit } from './components';
import style from './ChangeLimitPopup.scss';

const popupClassNames = {
    inner: style.popupInner,
    close: style.closeBtn
};

const layerClassNames = {
    layout: style.layout
};

export const ChangeLimitPopup = ({
                                     title,
                                     portletType,
                                     initialValues,
                                     availablePeriods,
                                     actualLimits,
                                     valuesLimit,
                                     limitAction,
                                     fetchPortlet,
                                     id,
                                     controls,
                                     onClose,
                                     reFetchPicker
}) => {
    const closePopup = useCombinedOnClose(onClose, id);
    return (
        <ManagedPopup
            id={id}
            controls={controls}
            onClose={closePopup}
            className={style.containerLimit}
            classNames={popupClassNames}
            layerClassNames={layerClassNames}
            title={title}
        >
            <ChangeLimit
                onClose={closePopup}
                actualLimits={actualLimits}
                valuesLimit={valuesLimit}
                initialValues={initialValues}
                availablePeriods={availablePeriods}
                portletType={portletType}
                limitAction={limitAction}
                fetchPortlet={fetchPortlet}
                reFetchPicker={reFetchPicker}
            />
        </ManagedPopup>
    );
};
